<template>
  <div class="camera-scan-wrapper">
    <b-modal
      id="camera_scan_modal"
      hide-header
      hide-footer
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <div :class="currentLocale">
        <div class="body">
          <div class="top-wrapper">
            <strong>
              {{ lbl.scan_qr_modal.title }}
            </strong>
            <img
              src="@/assets/images/close-icon.svg"
              alt="close-icon"
              class="close"
              @click="onClose()"
            />
          </div>
          <!-- <qrcode-stream v-if="show" @detect="onDecode"></qrcode-stream> -->
          <!-- <div class="d-flex mb-3">
            <a-button class="mr-3" @click="onopen">
              <a-icon class="icontop2" type="retweet" />
              {{ !showscan ? 'QR & Barcode' : 'Text Scan' }}
            </a-button>
          </div> -->
          <div v-if="showscan" class="currentCodeContainer">
            <div class="currentCode">{{ text }}</div>
            <video
              ref="player"
              class="realtimeimage"
              autoplay
              muted
              playsinline
            ></video>
          </div>
          <a-button v-if="showscan" class="Capturebtn" @click="onDecode(text)"
            >Capture</a-button
          >
          <canvas ref="snapshot" class="realtimeimage himahe"></canvas>
          <div class="streamCOntainer">
            <StreamBarcodeReader
              v-if="show && !showscan"
              id="scan_code"
              :readers="readers"
              :formats="[
                'TEXT',
                'QR_CODE',
                'AZTEC',
                'CODABAR',
                'CODE_39',
                'CODE_93',
                'CODE_128',
                'DATA_MATRIX',
                'EAN_8',
                'EAN_13',
                'ITF',
                'MAXICODE',
                'PDF_417',
                'UPC_A',
              ]"
              @decode="onDecode"
            ></StreamBarcodeReader>
          </div>
          <div class="mt-3 mainuploadbtn">
            <input
              ref="qruploader"
              class="d-none"
              type="file"
              accept="image/*"
              @change="uploadFile"
            />
            <input
              ref="barcodeuploader"
              class="d-none"
              type="file"
              accept="image/*"
              @change="uploadBarcode"
            />
            <ImageBarcodeReader
              ref="ImageBarcodeReader"
              class="d-none"
              :formats="[
                'TEXT',
                'QR_CODE',
                'AZTEC',
                'CODABAR',
                'CODE_39',
                'CODE_93',
                'CODE_128',
                'DATA_MATRIX',
                'EAN_8',
                'EAN_13',
                'ITF',
                'MAXICODE',
                'PDF_417',
                'UPC_A',
              ]"
              @decode="onDecode"
              @error="onError"
            ></ImageBarcodeReader>
            <div v-if="false" class="warning-text d-flex">
              <div v-if="false">
                <a-button
                  :style="storeStyle"
                  class="uploadimagebtn iosqr"
                  @click="onSelectfiles('qr')"
                  >QR Code</a-button
                >
                <a-button
                  :style="storeStyle"
                  class="uploadimagebtn iosbar"
                  @click="onSelectfiles('bar')"
                >
                  Barcode</a-button
                >
              </div>
              <a-button
                v-else
                :style="storeStyle"
                class="uploadimagebtn"
                @click="onSelectfiles"
                >Upload QR Code/Barcode</a-button
              >
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <AlertError
      v-if="show"
      :show="showError"
      :data="dataError"
      @changeError="ChangeError($event)"
    />
  </div>
</template>

<script>
import AlertError from '@/components/Modal/AlertError'
import CommonMixin from '@/mixin/CommonMixin'
import ResponsiveMixin from '@/mixin/ResponsiveMixin'
import Locale from '@/helper/Locale.js'
// import { QrcodeStream } from 'vue-qrcode-reader'
import { StreamBarcodeReader, ImageBarcodeReader } from 'vue-barcode-reader'
import { BarcodeFormat, BrowserMultiFormatReader } from '@zxing/library'
import jsQR from 'jsqr'
import AccountHelper from '../../helper/AccountHelper'
import { createWorker, PSM, OEM } from 'tesseract.js'
// import javascriptBarcodeReader from 'javascript-barcode-reader'
const worker = createWorker({
  logger: m => console.log(m),
})

export default {
  components: {
    AlertError,
    StreamBarcodeReader,
    ImageBarcodeReader,
  },
  mixins: [CommonMixin, ResponsiveMixin],
  props: {
    show: Boolean,
    inputNumber: Number,
    storeStyle: Object,
  },
  data() {
    return {
      currentLocale: Locale.getLocale(),
      readers: new BrowserMultiFormatReader(),
      hints: new Map(),
      formats: [BarcodeFormat.QR_CODE, BarcodeFormat.DATA_MATRIX],
      showError: false,
      showscan: false,
      showimage: false,
      text: '',
      intervalCApture: null,
      dataError: {},
    }
  },
  computed: {
    device() {
      return AccountHelper.liffgetOS() == 'ios'
    },
  },
  watch: {
    show(val) {
      console.log('watch show ::', this.show)
      if (val) {
        this.$bvModal.show('camera_scan_modal')
        if (
          !(
            navigator.mediaDevices &&
            typeof navigator.mediaDevices.getUserMedia === 'function'
          )
        ) {
          console.error('getUserMedia is not supported by this browser')
          this.showError = true
          this.dataError = {
            title: this.lbl.error.errortitle,
            detail: 'This device is not supported by this browser',
          }
          this.$bvModal.hide('camera_scan_modal')
        }
      } else {
        this.$bvModal.hide('camera_scan_modal')
      }
    },
  },
  mounted() {},
  methods: {
    onSelectfiles() {
      this.$refs.barcodeuploader.click()
    },
    onopen() {
      this.showscan = !this.showscan
      if (!this.showscan) {
        clearInterval(this.intervalCApture)
      }
      navigator.mediaDevices
        .getUserMedia({
          audio: false,
          video: {
            facingMode: 'environment',
          },
        })
        .then(stream => {
          this.$refs['player'].srcObject = stream
        })
      // this.intervalCApture = setInterval(() => {
      //   this.capture()
      // }, 1000)
    },
    async capture() {
      let player = this.$refs['player']
      let snapshotZone = this.$refs['snapshot']
      const context = snapshotZone.getContext('2d')
      context.drawImage(player, 0, 0, snapshotZone.width, snapshotZone.height)

      await worker.load()
      await worker.loadLanguage('eng')
      await worker.initialize('eng', OEM.LSTM_ONLY)
      await worker.setParameters({
        tessedit_pageseg_mode: PSM.SINGLE_BLOCK,
      })
      const {
        data: { text },
      } = await worker.recognize(snapshotZone)
      this.text = text
      console.log(text)
    },
    onDecode(text) {
      this.showscan = false
      clearInterval(this.intervalCApture)
      console.log('🚀 ~ file: CameraScanModal.vue:120 ~ onDecode ~ text:', text)
      // text.then((res) => {
      //   console.log(res.content)
      //   this.$emit('result', {
      //   text: res.content,
      //   number: this.inputNumber,
      // })
      // this.$bvModal.hide('camera_scan_modal')
      // })
      this.$emit('result', {
        text: text,
        number: this.inputNumber,
      })
      this.$bvModal.hide('camera_scan_modal')
    },
    onClose() {
      this.$emit('close')
      this.showscan = false
      clearInterval(this.intervalCApture)
      this.$bvModal.hide('camera_scan_modal')
    },
    onError(error) {
      console.log(
        '🚀 ~ file: CameraScanModal.vue:205 ~ onError ~ error:',
        error,
      )
      this.$emit('error', error)
      this.$bvModal.hide('camera_scan_modal')
    },
    uploadBarcode(event) {
      let image = new Image()
      image.crossOrigin = 'Anonymous'
      image.src = URL.createObjectURL(event.target.files[0])
      this.reader = new BrowserMultiFormatReader()
      this.reader
        .decodeFromImage(image)
        .then(result => {
          this.$emit('result', {
            text: result.text,
            number: this.inputNumber,
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    uploadFile(event) {
      const file = event.target.files[0]
      const reader = new FileReader()
      reader.onload = event => {
        const img = new Image()
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')
          canvas.width = img.width
          canvas.height = img.height
          ctx.drawImage(img, 0, 0)
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
          // this.onDecode(imageData)
          const qrCode = jsQR(
            imageData.data,
            imageData.width,
            imageData.height,
            {
              inversionAttempts: 'dontInvert',
            },
          )
          if (qrCode) {
            console.log(qrCode.data)
            this.$emit('result', {
              text: qrCode.data,
              number: this.inputNumber,
            })
          } else {
            console.error('QR code not found')
            this.showError = true
            this.dataError = {
              title: this.lbl.error.errortitle,
              detail: 'QR code not found',
            }
          }
        }
        img.src = event.target.result
      }
      reader.readAsDataURL(file)
    },

    //Error
    ChangeError(event) {
      this.showError = event
      this.dataError = {}
    },
  },
}
</script>

<style lang="scss">
@import '@/style/_mixin.scss';

.mainuploadbtn {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
}

.uploadimagebtn {
  font-size: 16px;
  font-weight: 600;
  padding: 10px 40px;
  margin: 0 auto;
  border-radius: 100px;
  height: auto;
}

.iosqr {
  border-right: 2px solid rgb(255, 255, 255);
  border-radius: 100px 0 0 100px;
  padding: 10px 10px 10px 20px;
  font-size: 3.5vw;
}

.iosbar {
  border-radius: 0 100px 100px 0;
  padding: 10px 20px 10px 10px;
  font-size: 3.5vw;
}

.currentCodeContainer {
  position: relative;

  .currentCode {
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    background-color: #0000005b;
    color: white;
  }
}

.icontop2 {
  position: relative;
  top: -2px;
}

.Capturebtn {
  width: 90%;
  height: 48px;
  margin: 12px auto;
}

.realtimeimage {
  width: 100%;
  height: auto;
}

.himahe {
  visibility: hidden;
  display: none;
}

.modal-body {
  position: unset;
}

#camera_scan_modal > .modal-dialog {
  padding: 0;
  border-radius: 10px;

  .modal-content {
    background-color: #fff;
    position: fixed;
    margin: 0;
    top: 8%;
    left: 0;
    right: 0;
    bottom: 0;

    .modal-body {
      color: #616161;
      font-size: 14px;
      padding: 0;
      line-height: 1.57;
      letter-spacing: 0.15px;
      text-align: center;
      padding: 16px 0;

      .body {
        display: flex;
        flex-direction: column;
        align-items: center;

        .top-wrapper {
          display: flex;
          width: 100%;
          justify-content: space-between;
          margin: 8px 0px 16px;
          padding: 0 16px;

          strong {
            font-size: 18px;
          }

          .close {
            width: 25px;
            height: 25px;
          }
        }

        .bottom-wrapper {
          width: 100%;
          text-align-last: left;
          padding: 16px 32px 0;

          // position: fixed;
          // bottom: 0;
          // right: 0;
          // left: 0;
          // height: 60px;

          .warning-text {
            color: $color-error;
            margin: 8px auto;
            display: flex;
            justify-content: center;
          }
        }

        .title-wrapper {
          width: 100%;
          margin-bottom: 16px;

          img {
            height: 30px;
          }
        }

        .select-scan-type {
          margin-bottom: 16px;
        }

        .import-iamge-button {
          margin-top: 16px;
        }
      }
    }
  }
}
</style>
